export default function hasParamContact({ next, to })
{
    if (to.params.contact) {
        next();
    } else {
        next({ name: 'app-overview', params: to.params });
    }
}